import Vue from 'vue'
import dayjs from 'dayjs'

Vue.mixin({
  methods: {
    getDateToday() {
      let date = new Date()
      return new Date(date.getFullYear(), date.getMonth(), date.getDate())
    },

    parseDate(date) {
      let d = new Date(date)
      let day = `0${d.getDate()}`.slice(-2)
      let month = `0${d.getMonth() + 1}`.slice(-2)
      let year = d.getFullYear().toString()

      return `${day}/${month}/${year}`
    },

    convertToISO(date) {
      let d = date.split('/')
      let formatted = `${d[2]}-${d[1]}-${d[0]}`
      let iso = new Date(formatted).toISOString()

      return iso
    },

    getTimeDiff(date) {
      return dayjs().diff(dayjs(date), 'minutes') === 0
        ? 'Just now'
        : dayjs().diff(dayjs(date), 'minutes') < 60
        ? dayjs().diff(dayjs(date), 'minutes') + ' minutes ago'
        : dayjs().diff(dayjs(date), 'hour') < 24
        ? dayjs().diff(dayjs(date), 'hour') + ' hours ago'
        : dayjs().diff(dayjs(date), 'day') + ' days ago'
    },

    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  }
})
